'use client';

import styles from './page.module.css';
import './GalleryBlock.css';
import Image from 'next/image';
import { SimpleModal } from '@/features/Modal/SimpleModal';
import { useState } from 'react';
import { IGalleryBlock } from '../types';

const GalleryBlockClient: React.FC<IGalleryBlock> = ({ content, staticText }) => {
  const [modalState, setModalState] = useState(false);
  const [index, setIndex] = useState(0);

  const handleModalState = (i: number) => {
    setIndex(i);
    setModalState(!modalState);
  };
  const gallery = content.gallery.data;

  const modalProps = {
    modalState: modalState,
    type: 'gallery',
    content: {
      gallery,
      index,
    },
    handleModalState: handleModalState,
  };

  const base64Img =
    'data:image/bmp;base64,Qk32BAAAAAAAADYAAAAoAAAACAAAAAgAAAABABgAAAAAAMAAAAATCwAAEwsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQaACglDTAoP01OO0pNM0VML0NNNEdSPk5WRVNYSFVXbHN5anJ4ZW53Y213ZW96anN9bXZ9b3Z8hoyRhIqRgoiQgYiSg4uViI+Yi5GZjZKYk5mdk5idkpiek5mgl52knaKpoaespKmtmJ6fmJ6gmqCinqOnpKisqq+ysbW3tbq7mJ+dmqCenaOio6eoqq6vsra3ur6+v8TDmJ+bmaCdnqOipKmorLCwtLi4vcG/w8fF';

  return (
    <section className={'pageGallery projectWrapper'}>
      <SimpleModal modalProps={modalProps} />
      <h3 className={styles.pageGallery__title}>{content.title || staticText}</h3>
      <div className={styles.pageGallery__grid}>
        {content.gallery.data.map((e, i) => (
          <Image
            width={800}
            height={800}
            src={`https://api.blwall.com${e.attributes.url}`}
            alt="gallery item"
            className={styles.pageGallery__img}
            key={i}
            loading="lazy"
            onClick={() => {
              handleModalState(i);
            }}
            placeholder="blur"
            blurDataURL={base64Img}
          />
        ))}
      </div>
    </section>
  );
};

export default GalleryBlockClient;
